var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1.5C0.5 1.10218 0.658035 0.720645 0.93934 0.43934C1.22064 0.158036 1.60218 0 2 0H20C20.3978 0 20.7794 0.158036 21.0607 0.43934C21.342 0.720645 21.5 1.10218 21.5 1.5C21.5 1.89783 21.342 2.27936 21.0607 2.56066C20.7794 2.84197 20.3978 3 20 3H2C1.60218 3 1.22064 2.84197 0.93934 2.56066C0.658035 2.27936 0.5 1.89783 0.5 1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 9C0.5 8.60218 0.658035 8.22064 0.93934 7.93934C1.22064 7.65804 1.60218 7.5 2 7.5H20C20.3978 7.5 20.7794 7.65804 21.0607 7.93934C21.342 8.22064 21.5 8.60218 21.5 9C21.5 9.39783 21.342 9.77936 21.0607 10.0607C20.7794 10.342 20.3978 10.5 20 10.5H2C1.60218 10.5 1.22064 10.342 0.93934 10.0607C0.658035 9.77936 0.5 9.39783 0.5 9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 16.5C0.5 16.1022 0.658035 15.7206 0.93934 15.4393C1.22064 15.158 1.60218 15 2 15H11C11.3978 15 11.7794 15.158 12.0607 15.4393C12.342 15.7206 12.5 16.1022 12.5 16.5C12.5 16.8978 12.342 17.2794 12.0607 17.5607C11.7794 17.842 11.3978 18 11 18H2C1.60218 18 1.22064 17.842 0.93934 17.5607C0.658035 17.2794 0.5 16.8978 0.5 16.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleMenu);
export default __webpack_public_path__ + "static/media/toggle-menu.b05915031da94eb420c1563abda5734e.svg";
export { ForwardRef as ReactComponent };